module.exports = __webpack_public_path__ + "static/media/phenix.428e9831.jpg";